import { Injectable } from '@angular/core';
import { AppService } from '../../../../../core/service/Base.Service';


@Injectable()
export class CityService extends AppService<any> {

    constructor() {
        super('City');
    }

    async getCity(citycode: any) {
        const result = await this.get('City', citycode);
        return result;
    }

    async getCityByID(countryid: any) {
        const result = await this.get('CountryCity', countryid);
        return result;
    }

    async getCountryStateCity(countryid, stateid) {
        if (countryid > 0 && stateid > 0) {
            const result = await this.get('CountryStateCity', [countryid, stateid]);
            return result;
        }
    }   

        async CityData()
        {
            const result = await this.get('CityData');
            return result;   
        }
    
}





// WEBPACK FOOTER //
// ./src/app/shell/forms/organizational-setup/setup/City/City.service.ts